import Share from "@public/paper-plane-outline.png";
import Copy from "@public/copy.png";
import Image from "next/image";
import BudgetShareImage from "@public/manglish_budget_summariser_metaimage.webp";
import { DialogName, triggerDialog } from "@components/core/dialog";
import { t } from "@lingui/macro";
import { useFeedback } from "hooks/feedbackContext";
import {
  BudgetChatMessageProps,
  convertTopicsToParams,
  generateTopicsParams,
  getMessagesWithId,
  getResponses,
  messagesAtom,
  selectedStyleAtom,
} from "../constants/budget-atom";
import { useAtomValue } from "jotai";
import TurndownService from "@joplin/turndown";

const BudgetActionButtons: React.FC<{ messageId: string }> = ({
  messageId,
}) => {
  const { enqueueFeedback } = useFeedback();
  const messages = useAtomValue(messagesAtom);
  const style = useAtomValue(selectedStyleAtom);

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      enqueueFeedback(t`Content copied`);
    } catch (err) {
      const tempTextarea = document.createElement("textarea");
      tempTextarea.value = text;
      document.body.appendChild(tempTextarea);
      tempTextarea.select();
      document.execCommand("copy");
      document.body.removeChild(tempTextarea);
      enqueueFeedback(t`Content copied`);
    }
  };

  const onCopy = (messageId: string) => {
    const currentMessage = getResponses(messages)
      .filter((message) => message.messageId.toString() == messageId)
      .flatMap((message) => message.content)
      .join(`\n`);

    if (currentMessage) {
      const turndownService = new TurndownService();

      try {
        const markdown = turndownService.turndown(currentMessage);

        copyToClipboard(markdown);
      } catch (err) {
        enqueueFeedback("An error occured");
      }
    }
  };

  const openShareDialog = (
    event: React.MouseEvent,
    messages: BudgetChatMessageProps[],
    messageId: string,
    style: string
  ) => {
    var shareUrl;
    const topics =
      getMessagesWithId(messages, messageId).flatMap(
        (message) => message.topics
      ) || [];
    const topicsParams = generateTopicsParams(convertTopicsToParams(topics));

    if (topicsParams.length) {
      shareUrl = `${window.location.origin}/budget-2026-summariser?style=${style}&${topicsParams}`;
    } else {
      shareUrl = `${window.location}`;
    }

    event.preventDefault();

    triggerDialog(DialogName.share, {
      id: "id",
      url: shareUrl,
      showTitle: false,
      headerComp: (
        <Image
          className="h-[186px] w-[283px] rounded-lg"
          src={BudgetShareImage}
          alt="share"
          objectFit="cover"
        />
      ),
    });
  };

  return (
    <div className="flex flex-row space-x-2">
      <div
        className="transition-color cursor-pointer rounded-3xl px-1.5 pt-2 duration-300 hover:bg-light-background active:bg-light-background"
        onClick={(e) => {
          openShareDialog(e, messages, messageId, style);
        }}
      >
        <Image src={Share} height={22} width={22} alt="Share" />
      </div>
      <div
        className="transition-color cursor-pointer rounded-3xl px-1.5 pt-2 duration-300 hover:bg-light-background active:bg-light-background"
        onClick={() => onCopy(messageId)}
      >
        <Image src={Copy} height={23} width={23} alt="Copy" />
      </div>
    </div>
  );
};

export default BudgetActionButtons;
